<template>
  <div class="grid-wrap">
		<div class="grid-row">
			<article class="push__bottom">
				<div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
          <Section :section="this.sectionId" class="push__top" />
				</div>
				<Form 
					:error="$v.form.$error" 
					:formId="id" 
					:formErrorMessage="errorMessage"
					@submit="submitFormQuestion">
					<IntroForm 
						:title="question"
						:errorMessage="errorMessage"
						:validate="$v.form" 
						:id="id"
					>
        
          <template #content>
              <div class="wysiwyg">
                <p>Musculoskeletal (MSK) physiotherapy involves the assessment and treatment of muscles, tendons, ligaments, bones, joints, nerves and other structures in order to:</p>
                <ul>
                    <li>improve your movement and strength.</li>
                    <li>help you to do more of your normal activities.</li>
                    <li>help you to understand and manage your condition.</li>
                </ul>
                <p>Treatment is likely to include an exercise program specific to your needs.</p>
                <p>We are unable to accept a self referral under certain circumstances.  Please read and answer all of the following questions.</p>
                <h2>MSK Physiotherapy may not help if you:</h2>
                <ul>
                    <li>have had physiotherapy treatment for the same condition within the past year.</li>
                    <li>are referring yourself for widespread aches and pains. </li>
                    <li>have previously attended the Pain Clinic for the same condition.</li>
                </ul>
                <div class="soft__top soft__sides soft__bottom bg__highlight push__ends">
                    <h2 class="delta push__bottom--half">Please consult your GP URGENTLY or NHS 24</h2>
                    <h3 class="beta">Call NHS 24 on tel. no. <strong>111</strong></h3>
                    <p>If you have recently or suddenly developed:</p>
                    <ul class="list-disc">
                        <li>difficulty passing urine or controlling bladder / bowels</li>
                        <li>numbness or tingling around your back passage or genitals</li>
                        <li>numbness, pins and needles or weakness in both legs</li>
                    </ul>
                </div>
                <div class="soft__top soft__sides soft__bottom bg__highlight push__ends">
                    <h2 class="delta push__bottom--half">Please inform your GP of this self referral if you:</h2>
                    <ul class="list-disc">
                        <li>have recently become unsteady on your feet</li>
                        <li>are feeling generally unwell / fever</li>
                        <li>have a history of cancer</li>
                        <li>have any unexplained weight loss</li>
                    </ul>
                </div>
            </div>
            </template>
            <template #default>
              <div class="checkbox">
                <input class="checkbox__input" :id="'question' + options[0].id" name="nss" type="checkbox" :value="options[0]" v-model="form.acknowledged" @change="changeValue">
                <label class="label checkbox__label" :for="'question' + options[0].id">
                    {{options[0].label}}
                </label>
              </div>
              <div class="checkbox" v-show="testMode">
                <input class="checkbox__input" id="testMode" name="testMode" type="checkbox">
                <label class="label checkbox__label" :for="testMode">
                    Use test data and skip to the summary page?
                </label>
              </div>
            </template>
					</IntroForm>
				</Form>
				
			</article>
		</div>
	</div>
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "home",
  props: {
    title: String
  },
  data() {
    return {
      id: "",
      sectionId: null,
      question: "",
      error: false,
      errorMessage: "All fields are required",
      name: "",
      options: [],
      answer: null,
      testMode: null,
      form: {
        acknowledged: false,
        id: null,
        label: null,
        url: null,
        response: null
      }
    };
  },
  created() {
    this.loadQuestion();
	},
	mounted() {
		this.loadAnswer();
	},
  validations: {
    form: {
      acknowledged: { sameAs: sameAs( () => true ) },
    }
  },
  methods: {
    submitTestForm() {
      dataService.setTestData();
    },
    changeValue: function(newValue) {      
      this.answer = newValue;
    },
    submitForm(form, valid) {
      valid.$touch();
      if (valid.$pending || valid.$error) {
				setTimeout(() => {
					document.querySelector(".error-summary__link").focus()
				}, 0);
				return;	
			}
      if (document.getElementById("testMode").checked === true) {
        this.submitTestForm();
        this.$router.push({ name: "summary" });
      } else {
        this.logResponse();
        this.$router.push({ name: this.form.url.toLowerCase() });
      }
    },
    submitFormQuestion() {
      this.submitForm(this.form, this.$v.form);
    },
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.id = currentQuestion.id;
      this.sectionId = currentQuestion.sectionId;
      this.question = currentQuestion.question;
      this.name = currentQuestion.responseId;
      this.options = currentQuestion.options;
      this.errorMessage = currentQuestion.errorMessage;
      this.testMode = currentQuestion.testMode;
		},
		loadAnswer() {
			let previousResponse = dataService.wasAnsweredBefore(this.id);
      this.form.id = this.options[0].id;
      this.form.response = this.options[0].response;
      this.form.url = this.options[0].destination;
      this.form.label = this.options[0].label;		
      if (previousResponse) {
				let checkbox = document.getElementById('question0');
				checkbox.checked = true;
        this.form.acknowledged = checkbox.checked;
				this.changeValue;
      }
		},
    logResponse() {
      let response = {
        id: this.id,
        questionType: "Checkbox",
        responseId: this.id,
        response: this.form.response
      };
      dataService.logResponse(response);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>